import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@flat-ui";
import { useMediaQueryList } from "@hooks/use-media-query";
import { Box, Grid } from "@mui-wrapper";
import { CommonStyles, DEFAULT_INPUT_FONT_SIZE, DEFAULT_TITLE_FONT_SIZE } from "@styles/common-styles";

/**
 * Defines a single section item that has some content and a label,
 * i.e. label = "First Name" and content = <TextField>
 */

/**
 * Default skeleton for the input fields in the page section.
 */
const DEFAULT_INPUT_SKELETON = <Skeleton variant="text" sx={{
  width: "100%",
  height: "1.875rem"
}} />;

/** Full width grid size for the content column */
const FULL_WIDTH_GRID_SIZE = 12;

/**
 * Defines a single section item that has some content and a label,
 * i.e. label = "First Name" and content = <TextField>
 */
export function PageSectionItem(t0) {
  const $ = _c(28);
  const {
    item,
    shouldShowTopBorder,
    isLoading
  } = t0;
  const {
    isScreenMdOrSmaller
  } = useMediaQueryList();
  let t1;
  if ($[0] !== item.shouldKeepContentInlineOnSmallScreens) {
    t1 = item.shouldKeepContentInlineOnSmallScreens ? {
      xs: 6,
      sm: 4,
      md: 6,
      lg: 3
    } : {
      xs: 12,
      md: 6,
      sm: 4,
      lg: 3
    };
    $[0] = item.shouldKeepContentInlineOnSmallScreens;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const labelGridSize = t1;
  let t2;
  if ($[2] !== item.shouldKeepContentInlineOnSmallScreens) {
    t2 = item.shouldKeepContentInlineOnSmallScreens ? {
      xs: 6,
      sm: 8,
      md: 6,
      lg: 9
    } : {
      xs: 12,
      md: 6,
      sm: 8,
      lg: 9
    };
    $[2] = item.shouldKeepContentInlineOnSmallScreens;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const contentGridSize = t2;
  const t3 = shouldShowTopBorder && !item.shouldHideTopBorder ? CommonStyles.Borders.divider : "none";
  const t4 = item.shouldHideBottomBorder ? "none" : CommonStyles.Borders.divider;
  const t5 = item.shouldHidePaddingY ? "0" : "1.25rem";
  let t6;
  if ($[4] !== t3 || $[5] !== t4 || $[6] !== t5) {
    t6 = {
      width: "100%",
      borderTop: t3,
      borderBottom: t4,
      paddingY: t5,
      minHeight: "4.375rem"
    };
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== item.label || $[9] !== item.shouldKeepContentInlineOnSmallScreens || $[10] !== item.shouldLabelBold || $[11] !== labelGridSize) {
    t7 = item.label && <Grid sx={{
      display: "flex",
      alignItems: "center",
      fontSize: DEFAULT_INPUT_FONT_SIZE,
      fontWeight: item.shouldLabelBold ? "bold" : "normal",
      lineHeight: "1.5rem",
      whiteSpace: item.shouldKeepContentInlineOnSmallScreens ? "nowrap" : "normal"
    }} size={labelGridSize}>{item.label}</Grid>;
    $[8] = item.label;
    $[9] = item.shouldKeepContentInlineOnSmallScreens;
    $[10] = item.shouldLabelBold;
    $[11] = labelGridSize;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = item.shouldAlignToEnd ? "flex-end" : "flex-start";
  const t9 = item.shouldAddRightPadding && !isScreenMdOrSmaller ? "1.6875rem" : "0";
  let t10;
  if ($[13] !== t8 || $[14] !== t9) {
    t10 = {
      display: "flex",
      alignItems: "center",
      justifyContent: t8,
      fontSize: DEFAULT_TITLE_FONT_SIZE,
      lineHeight: "1.5rem",
      paddingRight: t9
    };
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = item.shouldContentTakeFullWidth ? FULL_WIDTH_GRID_SIZE : contentGridSize;
  let t12;
  if ($[16] !== isLoading || $[17] !== item.content || $[18] !== item.customSkeleton) {
    t12 = isLoading ? item.customSkeleton ?? DEFAULT_INPUT_SKELETON : <>{item.content}</>;
    $[16] = isLoading;
    $[17] = item.content;
    $[18] = item.customSkeleton;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t12) {
    t13 = <Grid sx={t10} size={t11}>{t12}</Grid>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t13 || $[25] !== t6 || $[26] !== t7) {
    t14 = <Box><Grid container={true} sx={t6}>{t7}{t13}</Grid></Box>;
    $[24] = t13;
    $[25] = t6;
    $[26] = t7;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
}